module.exports = __webpack_public_path__ + "static/media/logo124.ef82a034.png";